import * as React from 'react'; // for flow type
import { useEffect } from 'react';
import { connect } from 'react-redux';
import options from '../../../state/options/options.actions';
import playback from '../../../state/playback/playback.actions';
import useRefCallback from '../../../hooks/useRefCallback';

type Props = {
    to: number,
    overlayId: number,
    onEntered: Function,
    toggleOverlay: Function,
    overlays: Array<Object>,
    reduxPlay: Function,
    reduxPause: Function,
    reduxSeekTo: Function,
};

export const JumpTrigger = ({ onEntered, reduxSeekTo, to }: Props) => {
    const handleMounted = useRefCallback(
        () => {
            onEntered();
            reduxSeekTo(to);
        },
        [onEntered, reduxSeekTo, to]
    );

    useEffect(
        () => {
            handleMounted();
        },
        [handleMounted]
    );

    return null;
};

export const PauseTrigger = ({ reduxPause }: Props) => {
    const handleMounted = useRefCallback(
        () => {
            reduxPause();
        },
        [reduxPause]
    );

    useEffect(
        () => {
            handleMounted();
        },
        [handleMounted]
    );

    return null;
};

export const OverlayTrigger = ({ overlays = [{}], overlayId, toggleOverlay }: Props) => {
    const activeOverlay = overlays.find(overlay => overlay.overlayId === overlayId);

    const handleMounted = useRefCallback(
        () => {
            toggleOverlay(activeOverlay);
        },
        [toggleOverlay, activeOverlay]
    );

    useEffect(
        () => {
            handleMounted();
        },
        [handleMounted]
    );

    return null;
};

const mapStateToProps = (state: Object) => ({
    overlays: state.options.activeVideo.overlays,
});

const mapDispatchToProps = (dispatch: any) => ({
    toggleOverlay: overlay => dispatch(options.toggleOverlay(overlay)),
    reduxPlay: () => dispatch(playback.reduxPlay()),
    reduxPause: () => dispatch(playback.reduxPause()),
    reduxSeekTo: (to: number) => dispatch(playback.reduxSeekTo(to)),
});

export default {
    JumpTrigger: connect(
        mapStateToProps,
        mapDispatchToProps
    )(JumpTrigger),
    PauseTrigger: connect(
        mapStateToProps,
        mapDispatchToProps
    )(PauseTrigger),
    OverlayTrigger: connect(
        mapStateToProps,
        mapDispatchToProps
    )(OverlayTrigger),
};

// class TimeTrigger extends PureComponent<Props> {
//   componentDidMount = () => {
//     const {
//       type,
//       skip,
//       hide,
//       pause,
//       overlays,
//       overlayId,
//       pauseOnClick,
//       toggleOverlay,
//       show,
//       autoClose,
//     } = this.props;

//     switch (type) {
//     case 0:
//       skip(hide);
//       break;
//     case 1:
//       pause();
//       break;
//     case 2:
//       /* TODO - custom time trigger */
//       break;
//     case 3:
//       const overlay = overlays.find(x => x.overlayId === overlayId);

//       if (pauseOnClick) {
//         pause();
//       }
//       toggleOverlay(overlay);
//       if (autoClose) this._autoClose();
//       break;
//     default:
//     }
//   };

//   _autoClose = () => {
//     const { autoCloseTime, closeOverlayAndAnimateOut, play } = this.props;

//     this.close = setTimeout(() => {
//       console.log("Auto close")
//       closeOverlayAndAnimateOut();
//       play();
//       clearTimeout(this.close);
//     }, autoCloseTime);
//   };

//   close: TimeoutID;

//   render = () => "";
// }

// export default TimeTrigger;
